import { useMemo } from "react";
import { AuditoinnitCacheKeys } from "../../cacheKeys";
import * as Endpoint from "../../../../endpoints";
import { getSgApiService } from "../../../../sg-core/services/ApiService2";
import { useAuthContext } from "../../../auth/AuthenticationProvider";
import IAudit from "../../../interfaces/IAudit";
import { getAuditService } from "../../../services/auditService";
import { useSWROffline } from "../../../../sg-core/swr/useSWROffline";
import { ConfigInterface } from "swr";

export type IUseAuditHook = (auditGuid?: IAudit["guid"], config?: ConfigInterface<IAudit | null>) => {
    data: IAudit | null;
    fetching: boolean;
}

export const useAudit: IUseAuditHook = (auditGuid, config = {}) => {
    const { token, lang, anonymousSession } = useAuthContext();
    const service = getAuditService(getSgApiService(token), Endpoint.auditoinnit, anonymousSession);


    const fetcher = async (): Promise<IAudit | null> => {
        if (!auditGuid) return null;

        const auditData = await service.getAudit(auditGuid)

        if (auditData.isFailure) {
            throw auditData.error;
        }
        return auditData.value.audit;
    };

    const cacheKey = AuditoinnitCacheKeys(token, lang).AuditInstance(auditGuid || "null");
    const { data, isValidating } = useSWROffline(cacheKey, fetcher, {
        suspense: true,
        revalidateOnFocus: false,
        revalidateOnMount: true,
        revalidateOnReconnect: false,
        ...config
    });

    const rawData = data || null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating,
    }), [rawData, isValidating]);
};
